export default "__VITE_ASSET__5iiBTbnd__"